import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { EFProductWinAdd } from '@/components/UI/svg/mm100';
import { getImageLocal } from '@/utils/locals';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/mm100/h5/');

export default function Comp({ callBack }: any) {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('ecoflowpowerkitsseries');
    const { locale } = useRouter();
    const imgLocale = getImageLocal(locale, ['au', 'cn', 'za']);

    return (
        <div className={`${css.kitL} kitL`}>
            <div className="kit-ms1">{t(locale === 'cn' ? 'presale.product.kitL_ms1_h5' : 'presale.product.kitL_ms1')}</div>
            <div className="kit-img-a1">
                <EFPic name={['kitL3.webp', 'kitL3.jpg']} className="fullImgs" alt={t('presale.product.kitL_ms1')} />
            </div>
            <div className="kit-inter kit-inter1">
                <div className="kit-ms2">{t('presale.product.kitL_ms2')}</div>
                <div className="kit-ms3">{t('presale.product.kitL_ms3')}</div>
                <div className="kit-ms4">{t('presale.product.kitL_ms4')}</div>
            </div>
            <div className="kit-inter kit-inter2">
                <div className="kit-img1">
                    <EFPic name={[`kitL2_${imgLocale}.webp`, `kitL2_${imgLocale}.jpg`]} className="fullImgs" alt={t('presale.product.kitL_ms1')} />
                </div>
                <div className="kit-img2">
                    <div className="kit-img2-in">
                        <EFPic name={[`kitL1_${imgLocale}.webp`, `kitL1_${imgLocale}.jpg`]} className="fullImgs" alt={t('presale.product.kitL_ms1')} />
                        <div className="kit-ms-tips kit-ms-tipsa1">{t('presale.product.kitL_ms_tipsa1')}</div>
                        <div className="line line1"></div>
                        <div className="point point1"></div>
                        <div className="kit-ms-tips kit-ms-tipsa2">{t('presale.product.kitL_ms_tipsa2')}</div>
                        <div className="line line2"></div>
                        <div className="point point2"></div>
                        <div className="kit-ms-tips kit-ms-tipsb3">{t('presale.product.kitL_ms_tipsa3')}</div>
                        <div className="line line3"></div>
                        <div className="line-box"></div>
                        <div className="point point3"></div>
                        <div className="point point4"></div>
                        <div className="kit-ms-tips kit-ms-tipsb4">{t('presale.product.kitL_ms_tipsa4')}</div>
                        <div className="line line4"></div>
                        <div className="point point5"></div>
                    </div>
                </div>
                <div className="kit-ms5">
                    <span className="color-ms1">{t('presale.product.kitL_ms5_1')}</span>
                    {t(locale === 'kr' ? 'presale.product.kitL_ms5_2_h5' : 'presale.product.kitL_ms5_2')}
                </div>
                <div className="more-win-line">
                    <div className="more-win-fun more-win-fun2" onClick={() => callBack('PowerHub')}>
                        {t('presale.product.h5_learn_more')}
                        <span className="more-win-fun-icon">
                            <EFProductWinAdd />
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
}
